import axios, { AxiosInstance } from 'axios'
import https from 'https'

const CLIENT_CACHE = new Map<string, AxiosInstance>()

const buildCacheKey = (baseUrl: string, ignoreHttpsErrors?: boolean) =>
  `${baseUrl}|${ignoreHttpsErrors ? 'insecure' : 'secure'}`

const createHttpClient = (baseUrl: string, ignoreHttpsErrors?: boolean): AxiosInstance => {
  const httpsOptions = ignoreHttpsErrors
    ? {
        httpsAgent: new https.Agent({
          rejectUnauthorized: false,
        }),
      }
    : {}

  return axios.create({
    baseURL: baseUrl,
    withCredentials: true,
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    validateStatus: status => status < 500,
    ...httpsOptions,
  })
}

export const getServerSideHttpClient = (
  baseUrl: string,
  ignoreHttpsErrors?: boolean,
): AxiosInstance => {
  const cacheKey = buildCacheKey(baseUrl, ignoreHttpsErrors)
  const cachedClient = CLIENT_CACHE.get(cacheKey)

  if (cachedClient) {
    return cachedClient
  }

  const client = createHttpClient(baseUrl, ignoreHttpsErrors)
  CLIENT_CACHE.set(cacheKey, client)
  return client
}

export const resetServerSideHttpClientCache = () => {
  CLIENT_CACHE.clear()
}
